module.exports = __webpack_public_path__ + "static/media/Basal_6811.6cd6dda4.jpg";